import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_KARMA_PILL_ANCHOR } from '../anchors';

export const dashboardKarmaPillHint: Hint = {
  id: asHintId('dashboard:karma-pill'),
  version: 1,
  priority: 60,
  anchor: DASHBOARD_KARMA_PILL_ANCHOR,
  copy: {
    title: 'Your karma',
    body: 'This pill shows the karma points you have earned. Click it to view your karma page — your balance, recent grants, and how to keep climbing.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
